export enum BankTransactionStatusFilter {
  All = 'all',
  ToReview = 'toReview',
  Reviewed = 'reviewed',
}
